const SID_KEY = "ea_sid";
const EMAIL_KEY = "ea_email";
const USER_PROFILE_KEY = "ea_user_profile";

export interface CompanionSession {
  sid: string;
  email: string;
}

export interface UserProfile {
  agent_email?: string;
  agent_name?: string;
  name?: string;
  pfp?: string;
  email_id?: string;
}

export function saveCompanionSession(session: CompanionSession): void {
  localStorage.setItem(SID_KEY, session.sid);
  localStorage.setItem(EMAIL_KEY, session.email);
}

export function getCompanionSession(): CompanionSession | null {
  const sid = localStorage.getItem(SID_KEY);
  const email = localStorage.getItem(EMAIL_KEY);
  if (!sid || !email) {
    return null;
  }
  return { sid, email };
}

export function getUserProfile(): UserProfile | null {
  const raw = localStorage.getItem(USER_PROFILE_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as UserProfile;
  } catch {
    return null;
  }
}

export function setUserProfile(profile: UserProfile): void {
  localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(profile));
}

export function clearUserProfile(): void {
  localStorage.removeItem(USER_PROFILE_KEY);
}

export function clearCompanionSession(): void {
  localStorage.removeItem(SID_KEY);
  localStorage.removeItem(EMAIL_KEY);
  clearUserProfile();
}
